import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, CreditCard } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { usePreviewGuard } from "@/lib/preview";
import { typeLabel } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { LoanDetailView } from "@/components/loan/LoanDetailView";
import { PayoffLetterButton } from "@/components/loan/PayoffLetterButton";
import { CertificatePanel } from "@/components/loan/CertificatePanel";

export default function PortalLoan() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const { guard } = usePreviewGuard();
  const navigate = useNavigate();
  useEffect(() => {
    api.get(`/loans/${id}`).then((r) => setData(r.data)).catch((e) => setError(apiError(e).message));
  }, [id]);

  return (
    <div data-testid="portal-loan-detail">
      <Link to="/portal" className="mb-4 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground" data-testid="portal-back">
        <ArrowLeft className="h-4 w-4" /> My loans
      </Link>
      {error && <div className="py-16 text-center text-muted-foreground" data-testid="loan-not-found">{error}</div>}
      {data && (
        <>
          <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
            <div>
              <div className="eyebrow">{data.loan.loan_number} · {typeLabel(data.loan.interest_type)}</div>
              <h1 className="mt-2 flex flex-wrap items-center gap-3 text-3xl font-semibold tracking-tight">Loan details <StatusBadge status={data.summary.status} testid="loan-status-badge" /></h1>
              <div className="gold-rule mt-4 w-24" />
            </div>
            {data.summary.status !== "paid_off" && (
              <div className="flex flex-wrap gap-2">
                <PayoffLetterButton loan={data.loan} />
                <Button onClick={guard(() => navigate(`/portal/loans/${id}/pay`))} data-testid="loan-pay-now-button"><CreditCard /> Pay now</Button>
              </div>
            )}
          </div>
          <CertificatePanel loanId={data.loan.id} />
          <LoanDetailView data={data} readOnly />
        </>
      )}
    </div>
  );
}
